/**
 * Сабэкспертиза «Выпуск в ГО, закупки, ценовая характеристика».
 * Бэкенд: тип задачи expertiseType.name = go-procurement-pricing,
 * в API версий сабэкспертизы ex_type_name = go-pricing (см. SUB_EX_GO_PRICING).
 */

const DEFAULT_LOCAL_FILE = () => ({
  uuid: '',
  filename: '',
  size: 0,
  data: {},
  time_create: '',
})

/** Текущая версия структуры `data` (без миграций — сабэкспертиза ещё не на проде). */
export const EX_GO_PRICING_TEMPLATE_VERSION = 1

/** Основной Excel: листы планов вида «Выпуск в ГО и план (ФВ-n)». */
export const GO_PRICING_MAIN_SHEET_PREFIX = 'Выпуск в ГО и план (ФВ-'

/** Отдельные книги: ровно один лист с таким именем. */
export const GO_PRICING_SHEET_GO_RELEASE = 'Выпуск в ГО'
export const GO_PRICING_SHEET_PROCUREMENT = 'Закупки'
export const GO_PRICING_SHEET_PRICING = 'Ценовая характеристика'

/** Лист со справкой в типовом файле (может называться сокращённо). Не парсится в данные. */
export const GO_PRICING_HELP_SHEET_HINT =
  'Выпуск в ГО, закупки, ценовая характеристика'

export const EX_GO_PRICING_TEMPLATE = () => ({
  mnn: '',
  condition: '',
  vzn14: false,
  gnvlp: false,
  analysisDate: '',
  releaseForms: [{ name: '', packageCount: null }],
  sheets: [],
  file: DEFAULT_LOCAL_FILE(),
  goRows: [],
  goFile: DEFAULT_LOCAL_FILE(),
  procurementRows: [],
  /** Примечание под таблицей закупок (&lt;10 субъектов). */
  procurementSubjectsNote: '',
  procurementFile: DEFAULT_LOCAL_FILE(),
  pricingRows: [],
  pricingFile: DEFAULT_LOCAL_FILE(),
})
